import MarkerClusterer from '@googlemaps/markerclustererplus';
import {http} from '../core/http';
import {Location, StaLoc} from '../interfaces/misc';
import LatLng = google.maps.LatLng;

declare var staAjx: { ajaxNonce: string, ajaxUrl: string };

var mapElement: any = document.getElementById("attendeesMap");
let map: google.maps.Map;
const markers: google.maps.Marker[] = [];
let activeInfoWindow: any;
var locations: { [k: string]: Location } = {};
var found_locations: StaLoc[] = [];
var saved_locations: StaLoc[] = [];
var should_update = false;
const options = {
    center: {lat: 48.78232, lng: 9.17702},
    zoom: 6,
    disableDefaultUI: false,
    controlSize: 32,
    styles: [{
        stylers: [{
            saturation: -100
        }]
    }]
};

const cluster = mapElement.getAttribute("data-clustering");
const clusterImage = mapElement.getAttribute("data-clustering-img");

const mapPinYellowSVG = {
    path: "M53.29,98.08C66.16,77,84,46.58,84,34A34,34,0,0,0,16,34c0,12.61,17.81,43,30.68,64.11C48.36,100.82,51.92,100.82,53.29,98.08ZM50,13.42A20.55,20.55,0,1,1,29.45,34,20.52,20.52,0,0,1,50,13.42Z",
    fillColor: "var(--sta-primary)",
    fillOpacity: 1,
    strokeWeight: 0,
    rotation: 0,
    scale: 0.3,
    anchor: new google.maps.Point(15, 30),
};

document.addEventListener('DOMContentLoaded', function () {
    init().then(function () {
        console.log("map is ready")
    });
});

async function init() {
    await getAllPlacesNames();
    await getSavedLocations();
    await initMap();
    await activateEventListeners();
    await resetMap();
    await updateLocations();
}

async function initMap() {
    map = await new google.maps.Map(mapElement as HTMLElement, options);
    let requests = 0;
    const service = await new google.maps.places.PlacesService(map);
    //loop through locations and get all the infos
    for (let index in locations) {
        let location = locations[index];
        let place = findSavedPlace(location.query);

        if (place) {
            createMarker(place, index);
            if ((Object.keys(locations).length - 1) == Number(index)) {
                document.getElementById('attendeesWrapLoader').classList.add("d-none");
            }
        } else {

            requests++;

            //by default google places allows you to send only 10 requests per second, with setTimeout the problem is solved.
            setTimeout(function () {
                service.findPlaceFromQuery(location, (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                        should_update = true;
                        createMarker(results[0]?.geometry?.location, index);
                        if ((Object.keys(locations).length - 1) == Number(index)) {
                            document.getElementById('attendeesWrapLoader').classList.add("d-none");
                        }
                    }
                });
            }, requests * 500);
        }
    }
    console.log("Google Map total requests:", requests);
}

function createMarker(location: LatLng, index: any) {

    if (!location) return;

    let loc = locations[index];

    // Wir fügen alle Koordinaten in ein Array ein, damit wir sie am Ende in der Datenbank speichern können
    found_locations.push({
        name: loc.query,
        coordinates: {
            lat: location.lat(),
            lng: location.lng(),
        }
    })

    var infowindow = new google.maps.InfoWindow({
        content: document.body.querySelector('[data-name="'+loc.query+'"]').querySelector(".place-company-name").innerHTML
    });

    var marker = new google.maps.Marker({
        map,
        position: location,
        title: loc.query,
        icon: mapPinYellowSVG
    });

    google.maps.event.addListener(marker, "mouseover", () => {
        highlight(index)
    });

    google.maps.event.addListener(marker, "mouseout", () => {
        unhighlight(index)
    });

    google.maps.event.addListener(marker, "click", () => {

        if (activeInfoWindow) {
            activeInfoWindow.close();
        }

        infowindow.open({
            anchor: marker,
            map,
            shouldFocus: false,
        });

        activeInfoWindow = infowindow;
    });

    markers.push(marker);

    if (cluster) {
        new MarkerClusterer(map, markers, {
            imagePath: clusterImage,
        });
    }
}

function activateEventListeners() {
    var places = getAllPlacesElements();

    for (var i = 0; i < places.length; i++) {


        places[i].addEventListener("mouseover", function () {
            var markerObj = markers.find(m => m.getTitle() === this.getAttribute("data-name"));

            if (typeof markerObj != "undefined" && markerObj.getAnimation() != google.maps.Animation.BOUNCE) {
                markerObj.setAnimation(google.maps.Animation.BOUNCE);
            }

            if (activeInfoWindow) {
                activeInfoWindow.close();
            }
        });

        places[i].addEventListener("mouseout", function () {
            var markerObj = markers.find(m => m.getTitle() === this.getAttribute("data-name"));

            if (typeof markerObj != "undefined" && markerObj.getAnimation() == google.maps.Animation.BOUNCE) {
                markerObj.setAnimation(null);
            }

            if (activeInfoWindow) {
                activeInfoWindow.close();
            }
        });

        places[i].addEventListener("click", function () {
            var markerObj = markers.find(m => m.getTitle() === this.getAttribute("data-name"));

            var latLng = markerObj.getPosition(); // returns LatLng object

            map.setCenter(latLng);
            map.setZoom(11);

            if (activeInfoWindow) {
                activeInfoWindow.close();
            }
        });
    }
}

function getAllPlacesNames() {
    const nameElement = getAllPlacesElements();
    for (let i = 0; i < nameElement.length; i++) {
        let el = nameElement[i] as HTMLElement;

        locations[i] = {
            query: el.getAttribute("data-name"),
            fields: ["name", "geometry"],
        };
    }
}

function getAllPlacesElements() {
    return document.getElementsByClassName("place-item");
}

function resetMap() {
    var resetMap = document.getElementById("reset-map");
    resetMap.addEventListener("click", function () {

        for (let i = 0; i < markers.length; i++) {
            markers[i].setIcon(mapPinYellowSVG);
        }

        map.setCenter(options.center);
        map.setZoom(options.zoom);
        if (cluster) {
            // @ts-ignore
            new MarkerClusterer(map, markers, {
                imagePath:
                clusterImage,
            });
        }
    })
}

function highlight(index: number) {
    var id = "place" + (index);
    var element = document.getElementById(id);
    element.className += " place-item-hover";
}

function unhighlight(index: number) {
    var id = "place" + (index);
    var element = document.getElementById(id);
    element.classList.remove("place-item-hover");
}


// Z.M Update

function findSavedPlace(query: string) {
    let place: LatLng = null;

    if (saved_locations && query) {
        let loc = saved_locations.find(l => l.name === query);
        if (loc) {
            place = new LatLng(loc.coordinates.lat, loc.coordinates.lng);
        }
    }
    return place;
}

async function getSavedLocations() {
    saved_locations = await ajx();
}

async function updateLocations() {
    setTimeout(function () {

        if (should_update && found_locations.length > saved_locations.length) {
            ajx({
                ajx_action: 'update_locations',
                locations: found_locations
            });
        }
    }, 10000);
}

async function ajx(params: any = null) {
    try {
        let postData = {
            action: 'sta_maps_action',
            ajx_action: 'get_locations',
            nonce: staAjx.ajaxNonce,
        }

        if (params) {
            postData = Object.assign(postData, params);
        }

        return http.wp(staAjx.ajaxUrl, postData).then((res) => {
            return res;
        }).catch((e) => {
            console.error(e);
        });
    } catch (e) {
        console.error("ajx err: ", e);
    }
}





